import { createAction } from "@reduxjs/toolkit";

export const setUserIndicatorCollection = createAction<any>('userIndicatorCollection/setUserIndicatorCollection')